(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('CustomerTitle', CustomerTitle);

    CustomerTitle.$inject = ['$resource'];

    function CustomerTitle ($resource) {
        var resourceUrl =  'api/customer-titles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
